function checkCompare(ele){
  let parentObj = collectionCompare;
  const _self = $(ele).find(parentObj.compareInput);
  const items = parentObj._getItems();
  if(items.length < parentObj.maxActiveInputs || _self.hasClass('active')) {
    const item = _self.data('obj');
    _self.toggleClass('active');
    parentObj._updateItems(item);
    parentObj._checkStoredInputs();
    parentObj._checkDisableStyle();
    parentObj._checkPDP();
  }
}
const collectionCompare = {
  compareInput: '.compare-checkbox',
  compareInputWrapper: '.compare-button',
  maxActiveInputs: 4,
  localStorageVarName: 'compareProductIds',
  _init: function () {
    this._removeExpiredElements();
    // this._addCheckboxEvent();
    this._checkStoredInputs();
    this._checkDisableStyle();
    // for PDP
    this._checkPDP(true);
  },
  _addCheckboxEvent: function () {
    const parentObj = this;
    const inputs = $(parentObj.compareInputWrapper);
    if(inputs.length){
      inputs.on("click", function() {
        const _self = $(this).find(parentObj.compareInput);
        const items = parentObj._getItems();
        if(items.length < parentObj.maxActiveInputs || _self.hasClass('active')) {
          const item = _self.data('obj');
          _self.toggleClass('active');
          parentObj._updateItems(item);
          parentObj._checkStoredInputs();
          parentObj._checkDisableStyle();
          parentObj._checkPDP();
        }
      }); 
    }
  },
  _checkDisableStyle: function() {
    const inputs = $(this.compareInput);
    const items = this._getItems();
    if(items.length == 4) {
      for( input of inputs) {
        const $input = $(input);
        if(!$input.hasClass('active')) {
          const wrapper = $input.closest(this.compareInputWrapper);
          wrapper.addClass('disabled');
        }
      }
    }else {
      const inputWrappers = $(this.compareInputWrapper)
      inputWrappers.removeClass('disabled');
    }
    this._fillBar();
  },
  utf8_to_b64: function ( str ) {
    return window.btoa(unescape(encodeURIComponent( str )));
  },  
  _checkStoredInputs: function () {
    const items = this._getItems();
    if($(`${this.compareInput}`).length) {
      $(`${this.compareInput}`).removeClass('active');
    }
    for (item of items) {
      const input = $(`${this.compareInput}[item-id="${item.id}"]`);
      if (input) input.addClass('active');
    }
  },
  _getItems: function() {
    const storedData = JSON.parse(localStorage.getItem(this.localStorageVarName));
    const items = (storedData?.length > 0) ? storedData : [];
    return items;
  },
  _setItems: function(items) {
    localStorage.setItem(this.localStorageVarName, JSON.stringify(items));
  },
  
  _updateItems: function(item) {
    item.id64 = this.utf8_to_b64(`gid://shopify/Product/${item.id}`);
    this._checkSameType(item);
    let items = this._getItems();
    if(this._checkId(item)) {
      items = items.filter(i => i.id != item.id);
    } else {
      item = this._includeTTL(item);
      item.price = item.price_discount && (item.price_discount  != "false") ? item.price_discount : item.price;
      // add RPA
      if((typeof kanopiSurcharge !== 'undefined' || kanopiSurcharge._isSurchargeZone()) && (item.price_discount && (item.price_discount  != "false"))){
        let product_surcharge = item.product_surcharge ? JSON.stringify(item.product_surcharge) : item.product_surcharge;
        let variant_surcharge = item.surcharge ? JSON.stringify(item.surcharge) : item.surcharge;
        const surcharge = kanopiSurcharge._getProductSurchargeAmount({has_surcharge: `${item.has_surcharge}`, product_surcharge: `${product_surcharge }`, surcharge: `${variant_surcharge}`});
        item.price = kanopiSurcharge._getSurchargePriceHelper(item.price * 100, surcharge);
      } 
        
      items.push(item);
    }
    this._setItems(items);
    this._fillBar();
  },
  _checkSameType: function(item){
    let items = this._getItems();
    if(items.length && item.pdp_template != 'hybrid') {
      // If new item is diferent type product clean array
      const compareProduct = items.find(product => product.pdp_template != 'hybrid');
      if(compareProduct && item.pdp_template != compareProduct.pdp_template ) {
        const onlyHybrids = items.filter(product => product.pdp_template === 'hybrid');
        this._setItems(onlyHybrids); 
      }
    }

  },
  _checkId: function(item) {
    let items = this._getItems();
    return items.find(i => i.id == item.id)? true : false;
  },
  _fillBar: function() {
    const itemsContainers=$('.comparison-bar-item');
    itemsContainers.removeClass('active pre-active').html('');
    const items = this._getItems();
    items.forEach((item, index) => {
      let discountClass = item.price_discount && (item.price_discount  != "false") ? 'discount-price' : '';
      let label_starting = '';
      if (item.multiplePrices) {
        label_starting = 'Starting at';
      }
      let price = (item.price_discount != 0 && checkDateRange() && localStorage.getItem('applyDiscount') == 'true') ? item.price_discount : item.price;
      price = !price.toString().includes('$') ? "$"+this.roundDecimals(price) : price;

      const title = this._truncateStrings(item.name);
      $(itemsContainers[index]).addClass('active').html(`<div class="remove-btn" onclick="collectionCompare._removeItem(${item.id})"></div><div class='img-wrapper'><img src='${item.image}'></div><div class='content-wrapper'><p class='title'>${title}</p><p class='price mb-0 ${discountClass}'><span class='label_starting'>${label_starting}</span>${price}<span class='price-units'> /${item.price_label}</span></p></div>`);
    });
    this._checkPDP();
  },
  _availablePDP(product) {
    const template = product.pdp_template;
    return template === 'tile' || template === 'wall' || template === 'hybrid' ? true : false;
  },
  roundDecimals(number) {
    numberRegexp = new RegExp('\\d\\.(\\d){' + 2 + ',}'); 
    if (numberRegexp.test(number)) {       
        return Number(number).toFixed(2);
    } else {
        return Number(number).toFixed(2) === 0 ? 0 : number;  
    }
  },
  _checkPDP: function(firstLoad = false) {
    const items = this._getItems();
    if(typeof compareDataPDP != 'undefined' && items.length <= this.maxActiveInputs) {
      if(!this._checkId(compareDataPDP) && this._availablePDP(compareDataPDP)){
        // First not active to add CTA
        $('#comparison-bar-body .comparison-bar-item:not(.active):first')
          .addClass('pre-active')
          .html(`<div class="pre-active-wrapper"><p class="title">${this._truncateStrings(compareDataPDP.name)}</p><p class="add-compare mb-0"><a href="javascript:void(0);" onclick="collectionCompare._updateItems(compareDataPDP)">Add to compare</a></p></div>`)
          ;
      } else {
        if(firstLoad) {
          this._hideBar();
        }
      }
      $('#comparison-bar').show();
      $("#drift-frame-controller").hide();
      this._updateCompareBtn();
    } else if($('.template-collection.compareBar').length){//always open on collecton page
      $('#comparison-bar').show();
      $("#drift-frame-controller").hide();
      this._updateCompareBtn();
    }else { 
      $('#comparison-bar').hide();
    }
    back2TopLogic();
  },
  _checkSurcharge : function () {

  },
  _clearAll: function() {
    this._setItems([]);
    // to clean collection
    this._cleanHandle();
  },
  _toggleBar: function() {
    if($('#comparison-bar').hasClass('active')) {
      this._hideBar();
    } else {
      this._showBar();
    }
    back2TopLogic();
  },
  _showBar: function(){
    $('#comparison-bar').addClass('active');
    $("#drift-frame-controller").hide();
  },
  _hideBar: function() {
    $('#comparison-bar').removeClass('active');
    $("#drift-frame-controller").show();
  },
  _removeItem: function(id, cleanAll = true) {
    let items = this._getItems();
    items = items.filter(i => i.id != id);
    this._setItems(items);
    if(cleanAll) this._cleanHandle();
  },
  _cleanHandle: function() {
    $(this.compareInput).removeClass('active');
    this._checkStoredInputs();
    this._checkDisableStyle();
    this._checkPDP(); 
  },
  _truncateStrings: function(str) {
    const window_width = window.screen.width;
    let max_string_length = (window_width >= 768)? 30 : 20;
    max_string_length = (window_width > 900) ? 40 : max_string_length;
    max_string_length = (window_width > 1400)? 45 : max_string_length;
    const final_str = (str && str.length > max_string_length) ? str.substr(0, max_string_length-1) + '&hellip;' : str;
    return final_str;
  },
  _includeTTL: function(item) {
    const oneHourExpiration = 3600;// in minutes
    const now = new Date();
    let ttl = parseInt(comparationTtl,0) > 0 ? comparationTtl : oneHourExpiration;
    ttl = ttl* 1000;
    item.expiration = now.getTime() + ttl;
    return item;
  },
  _removeExpiredElements: function() {
    const items = this._getItems();
    for(item of items) {
      const now = new Date();
      if (now.getTime() > item.expiration) {
        this._removeItem(item.id, false);
      }
    }
  },
  _updateCompareBtn: function() {
    const items = this._getItems();
    const compareCTA = $('#comparison-bar-cta');
    if( items.length > 0){
      if( items.length > 1) {
        if(window.innerWidth <= 767){
          compareCTA
          .removeClass('disabled')
          .text(`compare ${items.length}`)
          .attr('href','/pages/compare-products');
        }else {
          compareCTA
          .removeClass('disabled')
          .text(`compare ${items.length} items`)
          .attr('href','/pages/compare-products');
        }
      }else{
        compareCTA
        .addClass('disabled')
        .text(`compare`)
        .attr('href','');
      }
      $('#comparison-bar').show();
      $('body').addClass('show-compare-bar');
      $('#drift-frame-controller').hide();
    } else {
      $('#comparison-bar').hide();
      $('body').removeClass('show-compare-bar');
      $('#drift-frame-controller').show();
    }
  }
}

$( document ).ready(function() {
  if($('body').hasClass('template-collection')) {
    collectionCompare._init();
  }
  if($('body').hasClass('template-product')) {
    collectionCompare._init();
  }
});
